module.exports = function() {
  return new Worker(__webpack_public_path__ + "7cef6fe05ef9cb0289ed.worker.js");
};